import React from "react";
import { RxCrossCircled } from "react-icons/rx";
import NoImage from "../images/no-image.png";
function SelectedUser(props) {
  return (
    <div className="col-12">
      <div className="userListPan mb-1">
        <ul>
          {props?.selectedUsers?.map((item, index) => {
            return (
              <li key={"u" + index}>
                <img
                  src={item?.profilePhoto || NoImage}
                  alt="user"
                  style={{ height: "25px", width: "25px" }}
                  referrerPolicy="no-referrer"
                />
                {item?.name}
                <RxCrossCircled
                  style={{ cursor: "pointer" }}
                  onClick={() => props?.onRemove(item)}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default SelectedUser;
